import { useQuery } from "@tanstack/react-query";
import React, { useEffect } from "react";
import { BsArrowLeft } from "react-icons/bs";
import { toast } from "react-hot-toast";
import { API } from "../../../constants/api";
import useAuthAxios from "../../../utils/baseAxios";
import { errorMessage } from "../../../utils/errorMessage";
import { useUser } from "../../../context/user-context";

const GiftcardPreview = ({
  setOpenGicardUpload,
  setOpenSelectCardValue,
  setOpenGiftcardPreview,
  cardName,
  denominationData,
}: any) => {
  const axiosInstance = useAuthAxios();
  const { userDetails } = useUser();

  const getAllBanks = async () => {
    const response = await axiosInstance.get(API.getBanks);
    return response.data;
  };

  const { data: allBanks, error: error1 } = useQuery({
    queryKey: ["all-banks"],
    queryFn: getAllBanks,
    retry: 1,
  });
  const getAllOldBanks = async () => {
    const response = await axiosInstance.get(API.getBanksDeex);
    return response.data;
  };

  const { data: allOldBanks, error: error2 } = useQuery({
    queryKey: ["all-old-banks"],
    queryFn: getAllOldBanks,
    retry: 1,
  });

  useEffect(() => {
    if (error1) {
      const newError = error1 as any;
      toast.error(errorMessage(newError?.message || newError?.data?.message));
    }
    if (error2) {
      const newError = error2 as any;
      toast.error(errorMessage(newError?.message || newError?.data?.message));
    }
  }, [error1, error2]);
  const defaultBank = userDetails?.user?.banks.find(
    (bank: any) => bank.isDefault
  );
  const accountName = defaultBank.accountName;
  const accountNumber = defaultBank.accountNumber;
  const bankcode = defaultBank.bankCode;
  return (
    <div className="fixed inset-0  flex font-manrope justify-start items-start pt-16 overflow-auto pb-16 bg-[#E7EBEE] dark:bg-primary_dark dark:bg-opacity-95  backdrop-blur-sm">
      <div
        className={` w-11/12 mds:w-8/12 md:7/12 border dark:border-[#303030] bg-white  rounded-xl mx-auto p-6 dark:bg-[#192025]   lgss:w-2/5 xxl:w-1/3 `}
      >
        <div className="w-full flex justify-start gap-6 items-center">
          <button
            onClick={() => {
              setOpenGiftcardPreview(false);
              setOpenSelectCardValue(true);
            }}
          >
            <BsArrowLeft className="text-black dark:text-white text-[20px]" />
          </button>
          <h4 className="text-gray-900 dark:text-gray-100 font-sora font-semibold text-[20px]">
            Preview card details
          </h4>
        </div>

        <div className="w-full mt-8">
          <div className=" border-b border-gray-200 dark:border-gray-600 py-5">
            <h4 className="text-secondary_button text-[13px] font-bold">
              Selling
            </h4>
            <h4 className=" mt-2 text-[16px] text-[#13181B] dark:text-gray-100 font-sora font-bold">
              {cardName}
            </h4>
          </div>
          <div className=" border-b border-gray-200 dark:border-gray-600 py-5">
            <h4 className="text-secondary_button text-[13px] font-bold">
              Denomination
            </h4>
            <div className="flex justify-start mt-2 text-[16px] text-[#13181B] dark:text-gray-100 items-center gap-2">
              {denominationData?.map((data: any, index: number) => (
                <h4 key={index} className=" ">
                  ${data.amount} x{data.numberOfCards};
                </h4>
              ))}
            </div>
          </div>
          <div className=" border-b border-gray-200 dark:border-gray-600 py-5">
            <h4 className="text-secondary_button text-[13px] font-bold">
              Total value
            </h4>
            <h4 className=" mt-2 text-[16px] text-[#13181B] dark:text-gray-100">
              $
              {denominationData
                .reduce(
                  (total: any, card: any) =>
                    total + card.amount * card.numberOfCards,
                  0
                )
                .toLocaleString("en-US")}
            </h4>
          </div>
          <div className=" border-b border-gray-200 dark:border-gray-600 py-5">
            <h4 className="text-secondary_button text-[13px] font-bold">
              Funds to receive
            </h4>
            <h4 className=" mt-2 text-[16px] text-[#13181B] dark:text-gray-100">
              {denominationData
                .reduce(
                  (total: any, card: any) =>
                    total + card.amount * card.numberOfCards * card.rate,
                  0
                )
                .toLocaleString("en-US")}{" "}
              NGN
            </h4>
          </div>

          <div className="border-b border-gray-200 dark:border-gray-600 py-5">
            <h4 className="text-secondary_button text-[13px] font-bold">
              Bank Destination
            </h4>

            {(() => {
              const matchedBank =
                allBanks?.data.find(
                  (allBank: any) => allBank.bankCode === bankcode
                ) ||
                allOldBanks?.data.find(
                  (newBank: any) => newBank.code === bankcode
                );
              return matchedBank ? (
                <h4 className="text-gray-900 dark:text-gray-100 mt-2 text-[16px] font-medium">
                  {accountNumber} - {matchedBank.bankName || matchedBank.name}
                </h4>
              ) : (
                <h4 className="text-gray-900 dark:text-gray-100 mt-2 text-[16px] font-medium">
                  {accountNumber}
                </h4>
              );
            })()}

            <h4 className="text-[#BE6B0A] dark:text-amber-400 text-[11px] mt-1">
              {accountName}
            </h4>
          </div>
        </div>

        <button
          onClick={() => {
            setOpenGiftcardPreview(false);
            setOpenGicardUpload(true);
          }}
          className="mt-16 bg-secondary_button flex justify-center items-center text-white text-[15px] font-medium h-[48px] w-full rounded-xl"
        >
          Proceed to upload card
        </button>
      </div>
    </div>
  );
};

export default GiftcardPreview;
